import { api } from "../lib/axios"

interface CaseData {
  slug: string | undefined
}

export async function CaseFn({ slug }: CaseData) {
  
  const response = await api.get(`caseFull?slug=${slug}`)

  return response.data
}